export var __CAPTCHA_GET_URL__="https://api.akbank.com/api/v1/ldapaccessbase/captcha-get"
export var __FTP_URL__="https://ftpmerkezi.akbank.com/"
export var __COMPOSITE1__="https://api.akbank.com/api/v1/ldapaccessbase/reset-password"
export var __COMPOSITE2__="https://api.akbank.com/api/v1/ldapaccessbase/change-password-ad"
export var __COMPOSITE3__="https://api.akbank.com/api/v1/ldapaccessbase/otp-control"

